export interface PsgTypeWithNumItem {
    label: string;
    subLabel: string;
    value: string;
    actNum: number;
}

export interface CabinItem {
    label: string;
    value: string;
}

export interface airportItem {
    airportCode: string;
    airportName: string;
}

export interface hotCityItem {
    cityCode: string;
    cityName: string;
    countryCode?: string;
    countryName?: string;
    airportList?: airportItem[];
}

export interface hotCityGroup {
    groupName: string;
    cityList: hotCityItem[];
    groupCode: string;
    type: number;
}

export interface airlineItemVo {
    airlineCode2: string;
    airlineCode3: string | null;
    airlineLogo: string | null;
    airlineNameCn: string | null;
    airlineNameEn: string | null;
    airlineNameHk: string | null;
    airlineNameJa: string | null;
    airlineNameKo: string | null;
}

export interface HomeQueryParam {
    adultNum: number,
    childNum: number,
    infantNum: number,
    fromCity: {
        cityName: string;
        cityCode: string;
    },
    toCity: {
        cityName: string;
        cityCode: string;
    },
    fromDate: string;
    retDate: string;
    cabinGrades: string;
    tripType: string | number;
    fromCityInfo?: any;
    toCityInfo?: any;
}

export const newHotCityInfo = () => {
    const hotCityInfo: hotCityGroup[] = [];
    return hotCityInfo;
};

export const newCityInfo = () => {
    const cityInfo: hotCityItem = {
        cityCode: '',
        cityName: '',
    };
    return cityInfo;
};

export const newCityList = () => {
    const cityList: hotCityItem[] = [];
    return cityList;
};

//热门城市的lo vo赋值
export const convertHotCityLoToVo = (hotCityInfoVo: hotCityGroup[], hotCityInfoLo: hotCityGroup[]) => {
    Object.assign(hotCityInfoVo, hotCityInfoLo);
};